export default __webpack_public_path__ + "static/media/remove-circle-disabled.d32005a1.svg";